export default "/images/vendor/flag-icon-css/flags/4x3/bm.svg?4f2a386915b0a53e269fd01a1ce1f397";